module.exports = __webpack_public_path__ + "images/x-8d5ff19d.svg";